"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
var recommendedTemplateIds = [
    "62de4da0bf4f990007f04975",
    "62d767cd42549a00065e835d",
    "62d4d2ea27fc6a0006ac2202",
    "62d6bac4311c3d000691dd35",
    "62d602ae51de78000752dcb8",
    "62da40ee23afac000623ca87",
];
var recommendedTemplateSortOrder = [
    "62d4d2ea27fc6a0006ac2202",
    "62d767cd42549a00065e835d",
    "62d6bac4311c3d000691dd35",
    "62d602ae51de78000752dcb8",
    "62da40ee23afac000623ca87",
    "62de4da0bf4f990007f04975",
];
var ResultDisplayType;
(function (ResultDisplayType) {
    ResultDisplayType["Single"] = "single";
    ResultDisplayType["Group"] = "group";
    ResultDisplayType["Thumbnail"] = "thumbnail";
})(ResultDisplayType || (ResultDisplayType = {}));
var ResultsService = (function () {
    function ResultsService(templates, templateState) {
        this.getResults = function () {
            var templateList = templates.library;
            var searchTerm = templateState.searchTerm, dropdownItem = templateState.dropdownItem, useCase = templateState.useCase;
            if (searchTerm) {
                return {
                    results: templateList.filter(function (template) {
                        return template.name.toLowerCase().includes(searchTerm.toLowerCase());
                    }),
                    type: ResultDisplayType.Single,
                };
            }
            else if (dropdownItem === "my-templates") {
                return {
                    results: templateList.filter(function (template) {
                        return template.isAccountTemplate;
                    }),
                    type: ResultDisplayType.Single,
                };
            }
            else if (dropdownItem === "recommended") {
                var recommendedTemplates = templateList.filter(function (template) {
                    return recommendedTemplateIds.includes(template.projectId);
                });
                recommendedTemplates.sort(function (a, b) {
                    return recommendedTemplateSortOrder.indexOf(a.projectId) - recommendedTemplateSortOrder.indexOf(b.projectId);
                });
                return {
                    results: recommendedTemplates,
                    type: ResultDisplayType.Thumbnail,
                };
            }
            else {
                return {
                    results: getByGroup(function (template) {
                        return inDropdownItem(template, dropdownItem) && inUseCase(template, useCase);
                    }),
                    type: ResultDisplayType.Group,
                };
            }
        };
        var inDropdownItem = function (template, dropdownItem) {
            if (dropdownItem == undefined) {
                return false;
            }
            else if (dropdownItem === "all") {
                return true;
            }
            else {
                if (template.companyTypes) {
                    var companyTypes = template.companyTypes.map(lodash_1.default.kebabCase);
                    return lodash_1.default.includes(companyTypes, dropdownItem);
                }
                else {
                    return false;
                }
            }
        };
        var inUseCase = function (template, useCase) {
            if (useCase) {
                if (template.useCases) {
                    var useCases = template.useCases.map(lodash_1.default.lowerCase);
                    return lodash_1.default.includes(useCases, useCase);
                }
                else {
                    return false;
                }
            }
            else {
                return true;
            }
        };
        var getByGroup = function (filter) {
            var templateList = lodash_1.default.filter(templates.library, filter);
            return lodash_1.default.groupBy(templateList, function (template) {
                return template.category;
            });
        };
    }
    return ResultsService;
}());
exports.default = ResultsService;
